import React, { Component } from 'react'
import {
    Divider,
    Row,
    Col,
    Form,
    DatePicker,
    Button,
    Table,
    Tag,
    Tooltip,
    Modal,
    Select,
    Statistic,
    Input,
    Icon,
} from 'antd'
import NumberFormat from 'react-number-format'
import API from '../../../services/API'
import ShiftsReportDetail from '../components/ShiftsReportDetail'
import moment from 'moment'

const { RangePicker } = DatePicker

const Option = Select.Option

class ShiftsReportContainer extends Component {
    constructor(props) {
        super(props)
        let localSubsidiary = JSON.parse(localStorage.getItem('sucursal'))
        if (localSubsidiary) {
            localSubsidiary = localSubsidiary.id
        }

        this.state = {
            loading: false,
            query: '',
            total: 0,
            pagination: {},
            dateRange: {
                startDate: moment(),
                endDate: moment().add(1, 'days'),
                current: 'day',
            },
            initialCash: null,
            estimatedCash: null,
            finalCash: null,
            startDatetime: null,
            endDatetime: null,
            status: null,
            // dateFilter: null,
            shifts: {
                data: [],
                loading: false,
            },
            users: {
                data: [],
                loading: false,
                current: null,
            },
            subsidiaries: {
                data: [],
                loading: false,
                current: null,
            },
            checkouts: {
                data: [],
                loading: false,
                current: null,
            },
            localSubsidiary,
            current: false,
            // period: 'day',
        }
    }

    componentDidMount() {
        this.getSubsidiaries()
        this.getUsers()
        this.getCheckOuts()
        this.getData({
            page: 1,
        })
    }
    onModalClose = () => {
        this.setState({
            current: false,
        })
    }

    getUsers = async () => {
        this.setState({
            users: {
                data: [],
                loading: true,
                current: null,
            },
        })
        await API.get(`/api/users?pagination=false&filter[active]=1`)
            .then(response => {
                this.setState({
                    users: {
                        data: response.data,
                        loading: false,
                        current: null,
                    },
                })
            })
            .catch(err => {
                console.error('Este es el response: ', err)
            })
    }

    getCheckOuts = async (value = '') => {
        this.setState({
            checkouts: {
                data: [],
                loading: true,
                current: null,
            },
        })
        let url = `/api/checkouts?pagination=false&filter[active]=1`
        if (value && value !== 'all') {
            url += `&filter[subsidiary_id]=${value}`
        }
        await API.get(url)
            .then(response => {
                this.setState({
                    checkouts: {
                        data: response.data,
                        loading: false,
                        current: null,
                    },
                })
            })
            .catch(err => {
                console.error('Este es el response: ', err)
            })
    }

    handleReset = clearFilters => {
        this.getData({
            page: 1,
        })
        clearFilters()
    }

    getColumnDateProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <DatePicker
                    style={{ width: 200, marginBottom: 10, display: 'block' }}
                    // value={selectedKeys[0]}
                    placeholder="Buscar"
                    onChange={date => {
                        console.log('select', date._d)
                        if (dataIndex === 'start_datetime') {
                            console.log('start')
                            this.setState({ startDatetime: date._d }, setSelectedKeys(date ? [date] : []))
                        }
                        if (dataIndex === 'end_datetime') {
                            console.log('end')
                            this.setState({ endDatetime: date._d }, setSelectedKeys(date ? [date] : []))
                        }
                    }}
                    format="DD/MM/YYYY"
                    onPressEnter={() => {
                        confirm()
                    }}
                />
                <Button
                    type="primary"
                     onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Cancelar
                </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
    })

    getColumnSearchProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Input
                    prefix={<Icon type="dollar" style={{ color: 'rgba(0,0,0,.25)' }} />}
                    ref={node => {
                        this.searchInput = node
                    }}
                    placeholder="Ingrese una cantidad."
                    value={selectedKeys}
                    onChange={e => {
                        console.log('dataindex', dataIndex)
                        if (dataIndex === 'initial_cash') {
                            this.setState({ initialCash: e.target.value })
                        }
                        if (dataIndex === 'estimated_cash') {
                            this.setState({ estimatedCash: e.target.value })
                        }
                        if (dataIndex === 'final_cash') {
                            this.setState({ finalCash: e.target.value })
                        }
                        setSelectedKeys(e.target.value ? e.target.value : [])
                    }}
                    onPressEnter={() => this.handleSearch(selectedKeys, confirm)}
                    style={{ width: 188, marginBottom: 8, display: 'block' }}
                />
                <Button
                    type="primary"
                    onClick={() => this.handleSearch(selectedKeys, confirm)}
                    icon="search"
                    size="small"
                    style={{ width: 90, marginRight: 8 }}
                >
                    Buscar
                </Button>
                <Button onClick={() => this.handleReset(clearFilters)} size="small" style={{ width: 90 }}>
                    Cancelar
                </Button>
            </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => this.searchInput.select())
            }
        },
    })

    getSubsidiaries = async () => {
        this.setState({
            subsidiaries: {
                ...this.state.subsidiaries,
                data: [],
                loading: true,
            },
        })

        await API.get('/api/subsidiaries?pagination=false&filter[active]=1')
            .then(response => {
                const current = !this.state.subsidiaries.current
                    ? this.state.localSubsidiary
                    : this.state.subsidiaries.current

                this.setState({
                    subsidiaries: {
                        data: response.data,
                        loading: false,
                        current: parseInt(current),
                    },
                })
            })
            .catch(err => {
                console.error('Este es el response: ', err)
            })
    }

    handleSearch = (selectedKeys, confirm, column) => {
        this.getData({
            page: 1,
        })
        confirm()
    }

    handleReset = clearFilters => {
        clearFilters()
    }

    getData = async ({ page = 1, filters = null, sorter = null }) => {
        let newQuery = `per_page=10&include=user,items,subsidiary,checkout&page=${page}`

        this.setState({
            shifts: {
                data: [],
                loading: true,
            },
            loading: true,
            total: 0,
        })

        // if (this.state.dateFilter) {
        //     const { dateFilter } = this.state
        //     newQuery += `&filter[created_at]=${dateFilter.format('YYYY-MM-DD')}`
        // }
        console.log("status ddata", this.state.status)
        if (this.state.status) {
            newQuery += `&filter[status]=${this.state.status}`
        }

        if (
            this.state.dateRange.startDate &&
            this.state.dateRange.endDate &&
            !(this.state.startDatetime || this.state.endDatetime)
        ) {
            const { dateRange } = this.state
            if (dateRange && dateRange.startDate && dateRange.endDate) {
                if (dateRange.startDate.format('YYYY-MM-DD') === dateRange.endDate.format('YYYY-MM-DD')) {
                    newQuery += `&filter[created_at]=${dateRange.startDate.format('YYYY-MM-DD')}`
                } else {
                    const endDate = `${dateRange.endDate.format('YYYY-MM-DD')} 23:59:59`
                    newQuery += `&dateRange=${dateRange.startDate.format('YYYY-MM-DD')},${endDate}`
                }
            }
        }
        const subsidiariesCurrent = !this.state.subsidiaries.current
            ? this.state.localSubsidiary
            : this.state.subsidiaries.current

        if (subsidiariesCurrent && subsidiariesCurrent != 'all') {
            newQuery += `&filter[subsidiary_id]=${subsidiariesCurrent}`
        }

        if (this.state.users.current && this.state.users.current != 'all') {
            newQuery += `&filter[user_id]=${this.state.users.current}`
        }
        if (this.state.startDatetime) {
            newQuery += `&filter[start_datetime]=${moment(this.state.startDatetime).format('YYYY-MM-DD')}`
        }

        if (this.state.endDatetime) {
            newQuery += `&filter[end_datetime]=${moment(this.state.endDatetime).format('YYYY-MM-DD')}`
        }

        if (this.state.checkouts.current && this.state.checkouts.current != 'all') {
            newQuery += `&filter[checkout_id]=${this.state.checkouts.current} `
            if (subsidiariesCurrent) {
                newQuery += `&filter[subsidiary_id]=${subsidiariesCurrent}`
            }
        }

        if (this.state.initialCash) {
            newQuery += `&filter[initial_cash]=${this.state.initialCash}`
        }

        if (this.state.estimatedCash) {
            newQuery += `&filter[estimated_cash]=${this.state.estimatedCash}`
        }

        if (this.state.finalCash) {
            newQuery += `&filter[final_cash]=${this.state.finalCash}`
        }

        await API.get('/api/shifts?' + newQuery)
            .then(response => {
                var url = new URL(response.data.first_page_url)
                var total = url.searchParams.get('total')

                this.setState({
                    shifts: {
                        data: response.data.data,
                        loading: false,
                    },
                    pagination: {
                        ...this.state.pagination,
                        total: response.data.total,
                    },
                    loading: false,
                    query: newQuery,
                    total: total,
                })
            })
            .catch(() => {
                this.setState({
                    shifts: {
                        ...this.state.shifts,
                        loading: false,
                    },
                    loading: false,
                })
            })
    }

    dateStart = (date, dateString) => {
        this.setState(
            {
                dateRange: {
                    ...this.state.dateRange,
                    startDate: dateString,
                },
            },
            () => {
                this.redirectGetData()
            }
        )
    }

    dateEnd = (date, dateString) => {
        this.setState(
            {
                dateRange: {
                    ...this.state.dateRange,
                    endDate: dateString,
                },
            },
            () => {
                this.redirectGetData()
            }
        )
    }

    handleTableChange = (pagination, filters, sorter) => {
        const pager = { ...this.state.shifts.pagination }
        pager.current = pagination.current
        this.setState({
            shifts: {
                pagination: pager,
            },
            loading: true,
        })
        this.getData({
            page: pagination.current,
            filters,
            sorter,
        })
    }

    getColumnStatusProps = dataIndex => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }}>
                <Select
                    placeholder="Estatus"
                    optionFilterProp="children"
                    style={{ width: '100%', padding: 5 }}
                    filterOption={(input, option) =>
                        option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                    }
                    onChange={key => {
                        this.setState({
                            status: key,
                        }, () => {console.log("------ state", this.state)})
                    }}
                >
                    <Option key="0" value="0">
                        Todos
                    </Option>
                    <Option key="zero" value="zero">
                        Todo en orden
                    </Option>
                    <Option key="leftover" value="leftover">
                        Sobrante
                    </Option>
                    <Option key="left" value="left">
                        Faltante
                    </Option>
                </Select>
                <div>
                    <Button
                        type="primary"
                        onClick={() => this.handleSearch(selectedKeys, confirm)}
                        icon="search"
                        size="small"
                        style={{ width: 90, marginRight: 8 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => {}}
                        size="small"
                        style={{ width: 90 }}
                        //  style={{ width: 150 }}
                    >
                        Cancelar
                    </Button>
                </div>
            </div>
        ),
        filterIcon: filtered => <Icon type="search" style={{ color: filtered ? '#1890ff' : undefined }} />,
        onFilterDropdownVisibleChange: visible => {
            if (visible) {
                setTimeout(() => {})
            }
        },
    })

    columns = [
        {
            title: 'Usuario',
            dataIndex: 'user.full_name',
        },
        {
            title: 'Sucursal',
            dataIndex: 'subsidiary.name',
            sorter: false,
            filtered: false,
        },
        {
            title: 'Caja',
            dataIndex: 'checkout_id',
            render: (label, row) => (row.checkout ? row.checkout.name : 'N/A'),
        },
        {
            title: 'Fecha inicio',
            dataIndex: 'start_datetime',
            sorter: true,
            ...this.getColumnDateProps('start_datetime'),
        },
        {
            title: 'Fecha fin',
            dataIndex: 'end_datetime',
            sorter: true,
            ...this.getColumnDateProps('end_datetime'),
        },
        {
            title: 'Efectivo inicial',
            dataIndex: 'initial_cash',
            render: (label, row) => (
                <NumberFormat
                    decimalScale={2}
                    fixedDecimalScale
                    thousandSeparator
                    prefix="$"
                    displayType="text"
                    value={row.initial_cash}
                />
            ),
            ...this.getColumnSearchProps('initial_cash'),
        },
        {
            title: 'Efectivo estimado',
            dataIndex: 'estimated_cash',
            render: (label, row) => (
                <NumberFormat
                    decimalScale={2}
                    fixedDecimalScale
                    thousandSeparator
                    prefix="$"
                    displayType="text"
                    value={row.estimated_cash}
                />
            ),
            ...this.getColumnSearchProps('estimated_cash'),
        },
        {
            title: 'Efectivo final',
            dataIndex: 'final_cash',
            render: (label, row) => (
                <NumberFormat
                    decimalScale={2}
                    fixedDecimalScale
                    thousandSeparator
                    prefix="$"
                    displayType="text"
                    value={row.final_cash}
                />
            ),
            ...this.getColumnSearchProps('final_cash'),
        },
        {
            title: 'Tarjeta final',
            dataIndex: 'card_amount',
            render: (label, row) => (
                <NumberFormat
                    decimalScale={2}
                    fixedDecimalScale
                    thousandSeparator
                    prefix="$"
                    displayType="text"
                    value={row.card_amount}
                />
            ),
            ...this.getColumnSearchProps('name'),
        },
        {
            title: 'Estatus',
            dataIndex: '',
            filtered: true,
            ...this.getColumnStatusProps('Estatus'),
            render: (label, row) => (
                <div>
                    {+row.final_cash === +row.estimated_cash ? <Tag color="green">Todo en orden</Tag> : null}

                    {+row.final_cash < +row.estimated_cash ? (
                        <Tag color="red">
                            {'Faltante de '}
                            <NumberFormat
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator
                                prefix="$"
                                displayType="text"
                                value={+row.estimated_cash - +row.final_cash}
                            />
                        </Tag>
                    ) : null}

                    {+row.final_cash > +row.estimated_cash ? (
                        <Tag color="blue">
                            {'Sobrante de '}
                            <NumberFormat
                                decimalScale={2}
                                fixedDecimalScale
                                thousandSeparator
                                prefix="$"
                                displayType="text"
                                value={+row.final_cash - +row.estimated_cash}
                            />
                        </Tag>
                    ) : null}
                </div>
            ),
        },
        {
            title: 'Acciones',
            dataIndex: '',
            render: (label, row) => (
                <Tooltip placement="topLeft" title="Ver detalles">
                    <Button
                        shape="circle"
                        icon="info-circle"
                        type="primary"
                        onClick={() => {
                            this.setState({
                                current: row,
                            })
                        }}
                    />
                </Tooltip>
            ),
        },
    ]

    render() {
        return (
            <div
                style={{
                    backgroundColor: 'white',
                    borderRadius: 3,
                    padding: '8px 16px 16px',
                }}
            >
                <Divider>Reporte general de turnos</Divider>

                <div style={{ margin: '12px 0' }}>
                    <Form>
                        <Row style={{ display: 'flex', justifyContent: 'flex-end' }}>
                            <Col lg={5}>
                                <Statistic title="Venta global" value={this.state.total} precision={2} prefix={'$'} />
                            </Col>

                            <Col lg={2}>
                                <Tooltip title="Generar hoja de calculo" placement="left">
                                    <Button
                                        style={{ marginRight: '10px' }}
                                        type="primary"
                                        shape="circle"
                                        icon="download"
                                        onClick={() =>
                                            (window.location.href =
                                                '/api/excel?table=shifts&pagination=false&json=false&' +
                                                this.state.query)
                                        }
                                    />
                                </Tooltip>
                            </Col>
                        </Row>

                        <Row gutter={16}>
                            <Col lg={5}>
                                <Form.Item label="Periodo">
                                    <Select
                                        style={{ width: '100%' }}
                                        value={this.state.dateRange.current || ''}
                                        onChange={(key, value) => {
                                            switch (key) {
                                                case 'day':
                                                    this.setState({
                                                        dateRange: {
                                                            startDate: moment(),
                                                            endDate: moment().add(1, 'days'),
                                                            current: 'Dia actual',
                                                        },
                                                    })
                                                    break
                                                case 'week':
                                                    this.setState({
                                                        dateRange: {
                                                            startDate: moment().startOf('week'),
                                                            endDate: moment().endOf('week'),
                                                            current: 'Semana actual',
                                                        },
                                                    })
                                                    break
                                                case 'month':
                                                    this.setState({
                                                        dateRange: {
                                                            startDate: moment().startOf('month'),
                                                            endDate: moment().endOf('month'),
                                                            current: 'Mes actual',
                                                        },
                                                    })
                                                    break
                                                case 'year':
                                                    this.setState({
                                                        dateRange: {
                                                            startDate: moment().startOf('year'),
                                                            endDate: moment().endOf('year'),
                                                            current: 'Año actual',
                                                        },
                                                    })
                                                    break
                                                case 'custom':
                                                    this.setState({
                                                        dateRange: {
                                                            startDate: moment(),
                                                            endDate: moment(),
                                                            current: 'custom',
                                                        },
                                                    })
                                                    break
                                                case 'dayCustom':
                                                    this.setState({
                                                        dateRange: {
                                                            startDate: moment(),
                                                            endDate: moment(),
                                                            current: 'dayCustom',
                                                        },
                                                    })
                                                    break
                                                default:
                                                    break
                                            }
                                            // this.setState({period: key});
                                        }}
                                        placeholder="Periodo"
                                    >
                                        <Option key="day" value="day">
                                            Día actual
                                        </Option>
                                        <Option key="week" value="week">
                                            Semana actual
                                        </Option>
                                        <Option key="month" value="month">
                                            Mes actual
                                        </Option>
                                        <Option key="year" value="year">
                                            Año actual
                                        </Option>
                                        <Option key="dayCustom" value="dayCustom">
                                            Dia Personalizado
                                        </Option>
                                        <Option key="custom" value="custom">
                                            Rango Personalizado
                                        </Option>
                                    </Select>
                                </Form.Item>
                            </Col>
                            {this.state.dateRange.current == 'custom' ? (
                                <Col lg={4}>
                                    <Form.Item label="Rango Inicial">
                                        <div>
                                            <RangePicker
                                                value={[this.state.dateRange.startDate, this.state.dateRange.endDate]}
                                                onChange={dateRange => {
                                                    this.setState({
                                                        dateRange: {
                                                            startDate: dateRange[0],
                                                            endDate: dateRange[1],
                                                            current: 'custom',
                                                        },
                                                    })
                                                }}
                                            />
                                        </div>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            {this.state.dateRange.current == 'dayCustom' ? (
                                <Col lg={4}>
                                    <Form.Item label="Fecha">
                                        <div>
                                            <DatePicker
                                                style={{ width: 200, marginBottom: 10, display: 'block' }}
                                                value={this.state.dateRange.endDate}
                                                placeholder="Fecha"
                                                onChange={date => {
                                                    this.setState({
                                                        dateRange: {
                                                            startDate: date,
                                                            endDate: date,
                                                            current: 'dayCustom',
                                                        },
                                                    })
                                                }}
                                                format="DD/MM/YYYY"
                                                onPressEnter={() => {}}
                                            />
                                        </div>
                                    </Form.Item>
                                </Col>
                            ) : null}
                            <Col lg={5}>
                                <Form.Item label="Sucursal">
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Selecciona una sucursal"
                                        optionFilterProp="children"
                                        value={this.state.subsidiaries.current}
                                        onChange={value => {
                                            this.setState(
                                                {
                                                    subsidiaries: {
                                                        ...this.state.subsidiaries,
                                                        current: value,
                                                    },
                                                },
                                                () => {
                                                    // callback
                                                    this.getCheckOuts(value)
                                                }
                                            )
                                        }}
                                        filterOption={(input, option) =>
                                            option.props.subsidiaries.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        <Option key={'0'} value={'all'}>
                                            TODAS
                                        </Option>
                                        {this.state.subsidiaries.data.map(g => (
                                            <Option key={g.id} value={g.id}>
                                                {g.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col lg={5}>
                                <Form.Item label="Caja">
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Selecciona una caja"
                                        optionFilterProp="children"
                                        value={this.state.checkouts.current}
                                        onChange={value => {
                                            this.setState({
                                                checkouts: {
                                                    ...this.state.checkouts,
                                                    current: value,
                                                },
                                            })
                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        <Option key={'0'} value={'all'}>
                                            TODAS
                                        </Option>
                                        {this.state.checkouts.data.map(g => (
                                            <Option key={g.id} value={g.id}>
                                                {g.name}
                                            </Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                            <Col lg={5}>
                                <Form.Item label="Usuario">
                                    <Select
                                        showSearch
                                        style={{ width: 200 }}
                                        placeholder="Selecciona un usuario"
                                        optionFilterProp="children"
                                        value={this.state.users.current}
                                        onChange={value => {
                                            this.setState({
                                                users: {
                                                    ...this.state.users,
                                                    current: value,
                                                },
                                            })
                                        }}
                                        filterOption={(input, option) =>
                                            option.props.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                        }
                                    >
                                        <Option key={'0'} value={'all'}>
                                            TODOS
                                        </Option>
                                        {this.state.users.data.map(g => (
                                            <Option key={g.id} value={g.id}>{`${g.name} ${g.last_name}`}</Option>
                                        ))}
                                    </Select>
                                </Form.Item>
                            </Col>
                        </Row>
                        <Row gutter={16}>
                            <Col lg={2}>
                                <br />
                                <br />
                                <Button onClick={this.getData}>Buscar</Button>
                            </Col>
                            <Col lg={2}>
                                <br />
                                <br />
                                <Button
                                    disabled={this.state.shifts.loading}
                                    onClick={() => {
                                        this.setState(
                                            {
                                                dateRange: {
                                                    startDate: null,
                                                    endDate: null,
                                                },
                                                shifts: {
                                                    data: [],
                                                    loading: false,
                                                },
                                                users: {
                                                    data: this.state.users.data,
                                                    loading: false,
                                                    current: null,
                                                },
                                                checkouts: {
                                                    data: this.state.checkouts.data,
                                                    loading: false,
                                                    current: null,
                                                },
                                                subsidiaries: {
                                                    data: this.state.subsidiaries.data,
                                                    loading: false,
                                                    current: parseInt(this.state.localSubsidiary),
                                                },
                                            },
                                            () => {
                                                this.getData({
                                                    page: 1,
                                                })
                                            }
                                        )
                                    }}
                                >
                                    Limpiar Filtros
                                </Button>
                            </Col>
                        </Row>
                    </Form>
                </div>

                <Row>
                    <Table
                        columns={this.columns}
                        rowKey={row => row.id}
                        dataSource={this.state.shifts.data}
                        pagination={this.state.pagination}
                        loading={this.state.loading}
                        onChange={this.handleTableChange}
                        bordered
                        size="small"
                    />
                </Row>

                <Modal
                    title="Detalle de turno"
                    visible={this.state.current}
                    onOk={this.onModalClose}
                    closable={false}
                    centered
                    width="50%"
                    footer={[
                        <Button key="submit" onClick={this.onModalClose}>
                            Cerrar
                        </Button>,
                    ]}
                >
                    {this.state.current ? <ShiftsReportDetail shift={this.state.current} /> : null}
                </Modal>
            </div>
        )
    }
}

export default ShiftsReportContainer
